import { RegisterForm as Form } from '@snapi/types';
import { Button } from '@snapi/luxury';
import { useForm } from 'react-hook-form';
import { useAuth } from '@snapi/ui-utils';
import { Input } from '@snapi/form';

interface RegisterFormProps {
  onRegister(): void;
}

export const RegisterForm: React.FC<RegisterFormProps> = ({ onRegister }) => {
  const { auth } = useAuth();
  const {
    register,
    formState: { isSubmitting },
    handleSubmit,
  } = useForm<Form>({});

  const onSubmit = async (form: Form) => {
    await auth.register(form);
    onRegister();
  };

  return (
    <form
      className="flex flex-1 flex-col gap-5"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Input
        className="w-[280px]"
        placeholder="Name"
        {...register('name', { required: true })}
        disabled={isSubmitting}
      />
      <Input
        className="w-[280px]"
        type="email"
        placeholder="E-mail"
        {...register('email', { required: true })}
        disabled={isSubmitting}
      />
      <Button size="lg" type="submit">
        Register
      </Button>
    </form>
  );
};
